import React from 'react'
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";

const HackingLogin = () => {
  return (
    <div>
      

<Container fluid className="min-vh-100 d-flex flex-wrap">
  <Row className="w-100">
    
    <Col className="my-3 col-sm-12 col-lg-6">
      <div className="p-4 bg-white">
        <h4 className="text-start fs-3">Login Into the Bank</h4>
        <p className="text-start">
          As a hacker, you should be able to login into the bank by performing a bruteforce attack.
        </p>

        <div className="mt-4 p-4 bg-white rounded border border-black border-1">
          <h2 className="mb-4 text-start">Login</h2>

          <Form>
            <Form.Group controlId="username" className="mb-3">
              <Form.Label className="text-start d-block">Username:</Form.Label>
              <Form.Control
                type="text"
                name="username"
                placeholder="Enter username"
              />
            </Form.Group>

            <Form.Group controlId="password" className="mb-3">
              <Form.Label className="text-start d-block">Password:</Form.Label>
              <Form.Control
                type="password"
                name="password"
                placeholder="Enter password"
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group>
              <Button
                type="submit"
                className="w-100"
                variant="primary"
                name="Login"
              >
                Login
              </Button>
              <Form.Control
                type="hidden"
                name="user_token"
                
              />
            </Form.Group>
          </Form>
        </div>
      </div>

      
    </Col>

    
    <Col className=" border col-lg-6 col-sm-12">
      <div className="container-fluid p-4">
        <div className="d-flex justify-content-between">
          <h4>Resources</h4>
          <Button
            variant="primary"
            className="rounded-pill"
            href="/security.php"
          >
            Change Security Level
          </Button>
        </div>

        <hr />

        <Row className="g-2">
          <Col xs={12} className="px-md-1  col-sm-6 col-md-6 col-lg-6">
            <Card>
              <Card.Img variant="top" src="https://indianhackerslab.com/images/bruteforce2.png" />
              <Card.Body>
                <Button
                  href="/tutorial.php?topic=bruteforce-attack"
                  variant="primary"
                  className="w-100"
                  
                >
                  Watch Tutorial
                </Button>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} sm={6} md={6} lg={6} className="px-md-1">
            <Card>
              <a target="_blank" href="/book/bruteforce-attack">
                <Card.Img variant="top" src="https://indianhackerslab.com/images/bruteforce-notes.webp" />
              </a>
              <Card.Body>
                <Button
                  href="/notes.php?topic=bruteforce-attack"
                  variant="primary"
                  className="w-100"
                >
                  Read Notes
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <hr />

        <div className="mt-3 d-flex bg-light">
  <Button
    href="/labs/bank/login.php"
    variant="danger"
    className="rounded-pill"
    style={{ float: 'left' }}
  >
    Test Client Website
  </Button>
</div>

<div className="mt-5 text-align-left">
  <h2 className="text-start">More Information</h2>
  
  <ul className='' >
    <li className=''>
      <strong><a
      className=''
        href="https://owasp.org/www-community/attacks/Brute_force_attack"
      >https://owasp.org/www-community/attacks/Brute_force_attack
      
      </a></strong>
    </li>
    <li>
      <strong>
      <a
        href="https://www.symantec.com/connect/articles/password-crackers-ensuring-security-your-password"
        target="_blank"
        
       
      > https://www.symantec.com/connect/articles/password-crackers-ensuring-security-your-password
      </a>
      </strong>
    </li>
    <li>
      <strong><a
        href="https://www.golinuxcloud.com/brute-force-attack-web-forms"
        target="_blank"
       
      >
        https://www.golinuxcloud.com/brute-force-attack-web-forms
      </a></strong>
    </li>
  </ul>
</div>


        
      </div>
    </Col>
  </Row>
</Container>




    </div>
  )
}

export default HackingLogin